/* eslint-disable no-console */
const UTM_PARAMS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'gclid',
  'msclkid',
  'fbclid',
  'utm_id',
  'gbraid',
  'wbraid',
  'ttclid',
  'li_fat_id',
  'dclid',
  'gclsrc',
];

const UTM_STORAGE_KEY = 'utm_values';
const UTM_TTL_MS = 90 * 24 * 60 * 60 * 1000; // 90 days

export const getUtmValuesFromQuery = (query) => {
  const utmValues = {};
  UTM_PARAMS.forEach((param) => {
    if (query[param]) {
      utmValues[param] = query[param];
    }
  });
  return utmValues;
};

export const saveUtmValuesToLocalStorage = (utmValues) => {
  try {
    const existingValues = JSON.parse(localStorage.getItem(UTM_STORAGE_KEY)) || {};
    // Reset on new definitive attribution signal to avoid mixing sets.
    const isNewAttribution = ['gclid', 'msclkid', 'fbclid', 'utm_source'].some(k => Object.prototype.hasOwnProperty.call(utmValues, k));
    const base = isNewAttribution ? {} : existingValues;
    const newValues = { ...base, ...utmValues, _ts: Date.now() };
    localStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(newValues));
  } catch (error) {
    console.error('Error saving UTM values to localStorage:', error);
  }
};

export const getUtmValuesFromLocalStorage = () => {
  try {
    const raw = JSON.parse(localStorage.getItem(UTM_STORAGE_KEY)) || {};
    const ts = typeof raw._ts === 'number' ? raw._ts : 0;
    // Missing/invalid timestamps are considered expired to avoid indefinite retention.
    if (!ts || Date.now() - ts > UTM_TTL_MS) {
      localStorage.removeItem(UTM_STORAGE_KEY);
      return {};
    }
    const { _ts, ...values } = raw;
    return values;
  } catch (error) {
    console.error('Error getting UTM values from localStorage:', error);
    return {};
  }
};
